import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import host from "../global";
import getCountryHint from "../utils/countryHint";

/**
 * What this organization can buy right now, its balance, and what the
 * pop-ups should suggest -- from GET /purchase-options. The server works out
 * the organization from the signed-in user, so nothing here is trusted for
 * pricing; it only decides what to show.
 *
 * `credit` is what the user just ran short of ("interviews" | "cvs").
 */
export default function usePurchaseOptions({ enabled = true, credit = "interviews" } = {}) {
  const [options, setOptions] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    const token = sessionStorage.getItem("accessToken");
    if (!token) return null;
    setLoading(true);
    setError(null);
    try {
      // The same country hint as the plan cards and checkout, so the top-up
      // is priced in the currency it will be charged in.
      const country = await getCountryHint();
      const res = await axios.get(`${host}/purchase-options`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { credit, country },
      });
      setOptions(res.data);
      return res.data;
    } catch (err) {
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  }, [credit]);

  useEffect(() => {
    if (enabled) reload();
  }, [enabled, reload]);

  return { options, loading, error, reload };
}
